import styled, { css } from 'styled-components';
import { Badge } from 'ui/badge';
import { colors, spacing } from 'ui/theme';

const WarningColors = css`
  color: ${colors.textWarning};
  background-color: ${colors.backgroundWarningSubtle};
  outline-color: ${colors.borderWarningSubtle};
`;

const ErrorColors = css`  
  color: ${colors.textDestructive};
  background-color: ${colors.backgroundDestructiveSubtle};
  outline-color: ${colors.backgroundDestructiveSubtle};`;

export const InvertedErrorBadge = styled(Badge)`
  opacity: 1;
  ${ErrorColors}
`;

export const InvertedWarningBadge = styled(Badge)`
  opacity: 1;
  ${WarningColors}
`;

export const Wrapper = styled.div`
  display: flex; 
  align-items: center;      
  gap: ${spacing.quarter};
`;
